const award = state => state.award;
const participantCompanies = state => state.participantCompanies;

export default {
  award,
  participantCompanies,
};
